export class StepHeaderTab {

  /**
   * tabçåå®¹
   */
  name: string;

  /**
   * ç¹å»tabçåè°å½æ°
   */
  clickFunc: Function;

  /**
   * è®¾ç½®tabç¦ç¨ç¶æ
   */
  disable: boolean;

  /**
   * è®¾ç½®é¼ æ æ¬æµ®æ ·å¼
   */
  defaultCursor = false;

  constructor(name: string, clickFunc: Function, disable: boolean, defaultCursor?: boolean) {
    this.name = name;
    this.clickFunc = clickFunc;
    this.disable = disable;
    this.defaultCursor = defaultCursor;
  }
}
